/**
 * API client de Templates de Orcamento (Bloco F item 5).
 *
 *   GET/POST    /api/templates-orcamento
 *   GET/PATCH/DELETE /api/templates-orcamento/{id}
 *   POST        /api/templates-orcamento/{id}/aplicar-em/{orcamento_id}
 *   POST        /api/templates-orcamento/clonar-de-orcamento/{orcamento_id}
 *               body: {nome, descricao}
 */

const PREFIXO = "/api/templates-orcamento";

export function listarTemplates(request, params = {}) {
  const usp = new URLSearchParams();
  if (params.ativo !== undefined) usp.set("ativo", params.ativo ? "true" : "false");
  if (params.busca) usp.set("busca", params.busca);
  if (params.unidade) usp.set("unidade", params.unidade);
  // Bloco F.9: filtro por tipo (ORCAMENTO | CONTRATO)
  if (params.tipo) usp.set("tipo", params.tipo);
  if (params.page) usp.set("page", params.page);
  if (params.pageSize) usp.set("page_size", params.pageSize);
  const qs = usp.toString();
  return request(`${PREFIXO}${qs ? `?${qs}` : ""}`);
}

export function obterTemplate(request, id) {
  return request(`${PREFIXO}/${id}`);
}

export function criarTemplate(request, dados) {
  return request(PREFIXO, {
    method: "POST",
    body: JSON.stringify(dados),
  });
}

export function atualizarTemplate(request, id, dados) {
  return request(`${PREFIXO}/${id}`, {
    method: "PATCH",
    body: JSON.stringify(dados),
  });
}

export function deletarTemplate(request, id) {
  return request(`${PREFIXO}/${id}`, { method: "DELETE" });
}

/**
 * Marca/desmarca este template como padrao da sua (unidade, tipo). Quando
 * padrao=true, desmarca os irmaos do mesmo tipo. Documentos gerados sem
 * template explicito passam a usar o padrao.
 */
export function marcarTemplatePadrao(request, id, padrao = true) {
  return request(`${PREFIXO}/${id}/marcar-padrao`, {
    method: "POST",
    body: JSON.stringify({ padrao }),
  });
}

export function aplicarTemplate(request, templateId, orcamentoId) {
  return request(
    `${PREFIXO}/${templateId}/aplicar-em/${orcamentoId}`,
    { method: "POST" },
  );
}

export function clonarTemplateDeOrcamento(request, orcamentoId, { nome, descricao = "" }) {
  return request(
    `${PREFIXO}/clonar-de-orcamento/${orcamentoId}`,
    {
      method: "POST",
      body: JSON.stringify({ nome, descricao }),
    },
  );
}

// ---------- Editor de templates (Fase 1) ----------

/** Catalogo de variaveis Jinja2 disponiveis (grupos + loops). */
export function obterVariaveisTemplate(request) {
  return request(`${PREFIXO}/variaveis`);
}

/**
 * Renderiza o HTML do template com dados de EXEMPLO (sem orcamento real),
 * para a aba de Pre-visualizacao. silentError: o editor mostra o erro de
 * sintaxe Jinja inline em vez de toast.
 */
export function previewTemplate(request, { html, tipo }) {
  return request(`${PREFIXO}/preview`, {
    method: "POST",
    body: JSON.stringify({ html: html || "", tipo: tipo || "CONTRATO" }),
    silentError: true,
  });
}

// ---------- Sub-recursos: TemplateAmbiente + TemplateItem ----------

const PREFIXO_AMB = "/api/template-ambientes";
const PREFIXO_ITEM = "/api/template-itens";

export function listarTemplateAmbientes(request, templateId) {
  return request(`${PREFIXO_AMB}?template=${templateId}`);
}

export function criarTemplateAmbiente(request, dados) {
  return request(PREFIXO_AMB, {
    method: "POST",
    body: JSON.stringify(dados),
  });
}

export function atualizarTemplateAmbiente(request, id, dados) {
  return request(`${PREFIXO_AMB}/${id}`, {
    method: "PATCH",
    body: JSON.stringify(dados),
  });
}

export function deletarTemplateAmbiente(request, id) {
  return request(`${PREFIXO_AMB}/${id}`, { method: "DELETE" });
}

export function listarTemplateItens(request, ambienteId) {
  return request(`${PREFIXO_ITEM}?ambiente=${ambienteId}`);
}

export function criarTemplateItem(request, dados) {
  return request(PREFIXO_ITEM, {
    method: "POST",
    body: JSON.stringify(dados),
  });
}

export function atualizarTemplateItem(request, id, dados) {
  return request(`${PREFIXO_ITEM}/${id}`, {
    method: "PATCH",
    body: JSON.stringify(dados),
  });
}

export function deletarTemplateItem(request, id) {
  return request(`${PREFIXO_ITEM}/${id}`, { method: "DELETE" });
}
